/** Milliseconds to wait before refetching after a Mastodon write, to allow instance propagation */
export const MASTODON_PROPAGATION_DELAY_MS = 8_000
